<template>
  <svg
    class="c-icon"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-label="icon.name"
    @click="$emit('click')"
    role="img"
  >
    <g
      :fill="fill"
      :stroke="stroke"
      v-html="icon.path"
      :class="[`fill-${colorClass}`, `storoke-${storokeClass}`]"
    ></g>
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'box',
      required: true,
    },
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
    color: {
      type: String,
    },
    opt: {
      type: Object,
      default: () => ({}),
    },
    colorClass: {
      type: String,
      default: '',
    },
    storokeClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * 指定したアイコンの表示情報をicon.jsから取得して返却
     * @return {object} - 各アイコンの表示情報のオブジェクト
     */
    icon() {
      if (!this.$icon || !this.$icon[this.name]) return {};
      return this.$icon[this.name];
    },
    option() {
      if (!this.opt) return {};
      return this.opt;
    },
    /**
     * 指定したアイコンSVGの塗りつぶし色を返却
     * @return {string} - SVGの塗りつぶし色のテキスト
     */
    fill() {
      if (!this.icon || !this.icon.fill) return undefined;
      if (this.icon.fill === '#FFF') return this.icon.fill;
      if (!this.color) return this.icon.fill;
      return this.color;
    },
    /**
     * 指定したアイコンSVGの枠線の色を返却
     * @return {string} - SVGの枠線の色のテキスト
     */
    stroke() {
      if (!this.icon || !this.icon.stroke) return undefined;
      if (this.icon.stroke === '#FFF') return this.icon.stroke;
      if (!this.color) return this.icon.stroke;
      return this.color;
    },
    /**
     * 指定したアイコンSVGのViewBoxを返却
     * @return {string} - SVGの枠線のViewBoxのテキスト
     */
    viewBox() {
      if (!this.icon.viewBox) return '0 0 24 24';
      return this.icon.viewBox;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~@/assets/scss/design-guideline/variables/color' as app_color;

.fill- {
  &red {
    fill: app_color.$red !important;
  }
  &redhover {
    fill: app_color.$redhover !important;
  }
  &coolblack {
    fill: app_color.$coolblack !important;
  }
  &coolgray {
    fill: app_color.$coolgray !important;
  }
  &coolgray {
    fill: app_color.$coolgray !important;
  }
  &coolgray1 {
    fill: app_color.$coolgray1 !important;
  }
  &coolgray2 {
    fill: app_color.$coolgray2 !important;
  }
  &coolgray3 {
    fill: app_color.$coolgray3 !important;
  }
  &coolgray4 {
    fill: app_color.$coolgray4 !important;
  }
  &coolgray5 {
    fill: app_color.$coolgray5 !important;
  }
  &coolgray6 {
    fill: app_color.$coolgray6 !important;
  }
  &white {
    fill: app_color.$white !important;
  }
  &linktext {
    fill: app_color.$linktext !important;
  }
  &linktexthover {
    fill: app_color.$linktexthover !important;
  }
  &errored {
    fill: app_color.$errored !important;
  }
  &erroredbg {
    fill: app_color.$erroredbg !important;
  }
  &redpink {
    fill: app_color.$redpink !important;
  }
  &blue {
    fill: app_color.$blue !important;
  }
  &orange {
    fill: app_color.$orange !important;
  }
  &pink {
    fill: app_color.$pink !important;
  }
  &lightyellow {
    fill: app_color.$lightyellow !important;
  }
  &kyutokucolor {
    fill: app_color.$kyutokucolor !important;
  }
}

.storoke- {
  &red {
    stroke: app_color.$red !important;
  }
  &redhover {
    stroke: app_color.$redhover !important;
  }
  &coolblack {
    stroke: app_color.$coolblack !important;
  }
  &coolgray {
    stroke: app_color.$coolgray !important;
  }
  &coolgray {
    stroke: app_color.$coolgray !important;
  }
  &coolgray1 {
    stroke: app_color.$coolgray1 !important;
  }
  &coolgray2 {
    stroke: app_color.$coolgray2 !important;
  }
  &coolgray3 {
    stroke: app_color.$coolgray3 !important;
  }
  &coolgray4 {
    stroke: app_color.$coolgray4 !important;
  }
  &coolgray5 {
    stroke: app_color.$coolgray5 !important;
  }
  &coolgray6 {
    stroke: app_color.$coolgray6 !important;
  }
  &white {
    stroke: app_color.$white !important;
  }
  &linktext {
    stroke: app_color.$linktext !important;
  }
  &linktexthover {
    stroke: app_color.$linktexthover !important;
  }
  &errored {
    stroke: app_color.$errored !important;
  }
  &erroredbg {
    stroke: app_color.$erroredbg !important;
  }
  &redpink {
    stroke: app_color.$redpink !important;
  }
  &blue {
    stroke: app_color.$blue !important;
  }
  &orange {
    stroke: app_color.$orange !important;
  }
  &pink {
    stroke: app_color.$pink !important;
  }
  &lightyellow {
    stroke: app_color.$lightyellow !important;
  }
  &kyutokucolor {
    stroke: app_color.$kyutokucolor !important;
  }
}
</style>
